import { defineRule } from 'vee-validate'

const registrationNumber = () => {
  defineRule<string, any[]>(
    'registration_number',
    (value, _target, _ctx: any) => {
      if (!value) {
        return true
      }
      return testRegistrationNumber(value)
    },
  )
}

export default registrationNumber
